/*
 *
 *  * Copyright (c) 2018-2019 AccelByte Inc. All Rights Reserved.
 *  * This is licensed software from AccelByte Inc, for limitations
 *  * and restrictions contact your company contract manager.
 *
 */

import { default as React } from "react";
import { default as Styles } from "./Toast.module.scss";
import { default as classNames } from "classnames";
import { qa } from "../../../utils/qa";

export type ToastType = "error" | "warning" | "success";

interface Props {
  type: ToastType;
  message: string;
  isDisplayed: boolean;
}

const Toast = ({ type, message, isDisplayed }: Props) => {
  return (
    <div
      className={classNames(Styles.toastContainer, {
        [Styles.isDisplayed]: isDisplayed,
      })}
    >
      <i
        className={classNames("icon", {
          "icon-ab-warning-circle-filled": type === "error",
          "icon-ab-warning-filled": type === "warning",
          "icon-ab-check-circle-filled": type === "success",
        })}
      />
      <div className={Styles.toastMessage} data-qa-id={qa("toast_message")}>
        {message}
      </div>
    </div>
  );
};

export default Toast;
